var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-view",style:(_vm._style),on:{"click":_vm.click}},[(_vm.label)?_c('div',{staticClass:"label",style:(_vm._labelStyle)},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"switch",style:(_vm._switchStyle)},[_c('div',{staticClass:"knob",style:(_vm._knobStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }